@let rowData = firstCell();

<div class="flex justify-between" data-testid="case-tracking-row">
  <div class="flex gap-2 items-center">
    <div class="max-h-[56px]">
      <div class="max-h-[24px] min-w-[280px] flex">
        <div class="min-w-[140px] font-bold">Case #{{ caseNumber() }}</div>
        <div class="min-w-[140px]">({{ rowData.incidents.length }}/{{ rowData.incidents_count }} incident(s))</div>
      </div>

      <div class="max-h-[24px] text-sm italic">
        {{ locationName() }}
      </div>
    </div>

    <app-pan-chip
      [width]="150"
      [color]="getStatusColor(rowData.status)"
      [matTooltipDisabled]="!rowData.viewers?.[0]?.last_access"
      matTooltip="Status changed at {{ rowData.viewers?.[0]?.last_access | date: 'medium' }}"
    >
      <span [ngClass]="[rowData.viewers?.[0]?.last_access ? 'underline decoration-dotted' : '']">
        {{ getStatusText(rowData.status) }}
      </span>
    </app-pan-chip>
  </div>

  <div class="flex flex-col text-sm min-w-[340px]">
    <div class="flex gap-2 justify-between">
      <div class="flex-1 font-bold">Most Recent Incident:</div>
      <div class="flex-1">{{ rowData.most_recent_incident_date | date: "mediumDate" }}</div>
    </div>

    @if (rowData.most_recent_incident_date.getDate() !== rowData.first_incident_date.getDate()) {
      <div class="flex gap-2 justify-between">
        <div class="flex-1 italic">First Incident:</div>
        <div class="flex-1">{{ rowData.first_incident_date | date: "mediumDate" }}</div>
      </div>
    }
  </div>

  <div class="flex gap-2 justify-end min-w-[170px]" [class.invisible]="!params.node.expanded">
    <a
      panButton
      target="_blank"
      icon="fact_check"
      color="info"
      fill="outline"
      matTooltip="View Case Report"
      [routerLink]="['/shared/theft-report/' + rowData.theft_report_share_key]"
      [queryParams]="{ case_id: rowData.id }"
    >
    </a>

    <app-pan-button
      [state]="isResolving() ? 'loading' : 'default'"
      [disabled]="isResolving()"
      [color]="rowData.status !== 'Resolved' ? 'primary' : 'default'"
      (click)="toggleResolveCase()"
      [icon]="rowData.status === 'Resolved' ? 'replay' : 'check'"
      [matTooltip]="rowData.status === 'Resolved' ? 'Unresolve This Case' : 'Resolve This Case'"
    >
    </app-pan-button>

    <div [matTooltip]="!params.hasShareHistory?.(rowData.id) ? 'No sharing history available.' : ''">
      <app-pan-button
        panButton
        icon="history"
        color="info"
        fill="outline"
        [routerLink]="params.hasShareHistory?.(rowData.id) ? [rowData.id, 'share-history'] : null"
        [disabled]="!params.hasShareHistory?.(rowData.id)"
      >
      </app-pan-button>
    </div>
  </div>
</div>
